import { Box, CircularProgress, DialogActions, IconButton } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import FeatherIcon from "feather-icons-react";
import { Formik } from "formik";
import React from "react";
import { useSnackbar } from "../../components/toast/index.jsx";
import { DraggableDialog } from "../../consts.js";
import { AGENT_NAME_UPDATE_FAILED, AGENT_NAME_UPDATE_SUCCESS } from "../../helpers/messages.js";
import Utils from "../../utils.js";
import { AgentNameSchema } from "./validator.js";

const EditAgentNameComponent = ({ open, onClose, onSuccess, data }) => {
    const showSnackbar = useSnackbar();

    const initialValues = {
        name: data?.agent || "",
    }

    /**
     * Submit Method to create a campaign
     */
    const submitForm = async (values, { setSubmitting }) => {
        try {
            setSubmitting(true);
            await Utils.genericMutation("updateConversation", {
                id: data?.id,
                agent: values.name,
            });
            showSnackbar(AGENT_NAME_UPDATE_SUCCESS)
            onSuccess();
            setSubmitting(false);
        } catch (error) {
            showSnackbar(AGENT_NAME_UPDATE_FAILED, "error");
            setSubmitting(false);
        }
    }

    const handleClose = (event, reason) => {
        // Prevent closing the dialog on backdrop click or escape key press
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            return;
        }
        event.stopPropagation();
        onClose(null);
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="draggable-dialog-title"
            scroll="paper"
            disableEscapeKeyDown={true}
            fullWidth={true}
            maxWidth="xs"
            PaperComponent={DraggableDialog}
            onClick={(e) => e.stopPropagation()}
        >
            <DialogTitle
                id="draggable-dialog-title"
                display="flex"
                flexDirection="row"
                justifyContent="space-between"
                gap={1}
            >
                Edit Agent Name
                <IconButton
                    className="draggable-cancel"
                    size="small"
                    aria-label="close"
                    onClick={handleClose}
                    sx={(theme) => ({
                        color: theme.palette.grey[400],
                        marginRight: "-.5rem",
                    })}
                >
                    <FeatherIcon icon="x" />
                </IconButton>
            </DialogTitle>
            <Formik
                enableReinitialize
                validationSchema={AgentNameSchema}
                initialValues={initialValues}
                onSubmit={(values, actions) => {
                    submitForm(values, actions);
                }}
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    errors,
                    touched,
                    isSubmitting,
                }) => (
                    <Box
                        component="form"
                        display="flex"
                        flexDirection="column"
                        flexGrow={1}
                        overflow="auto"
                        noValidate
                        onSubmit={handleSubmit}
                    >
                        <DialogContent dividers sx={{ paddingY: 3 }}>
                            <TextField
                                id="outlined-basic"
                                variant="outlined"
                                fullWidth={true}
                                label="Agent Name"
                                required
                                name={"name"}
                                value={values.name}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched.name && !!errors.name}
                                helperText={touched.name ? errors.name : ''}
                            />

                        </DialogContent>
                        <DialogActions>
                            <Button
                                type="button"
                                variant="outlined"
                                onClick={handleClose}
                            >
                                Cancel
                            </Button>
                            <Button
                                type="submit"
                                variant="contained"
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? <CircularProgress color="inherit" size={24} /> : "Save"}
                            </Button>
                        </DialogActions>
                    </Box>
                )}
            </Formik>
        </Dialog>
    );
}

export default EditAgentNameComponent;